import React, { useState } from "react";
import { Box, Grid, Typography, CircularProgress } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import {
  faUsers,
  faClipboardCheck,
  faPoll,
} from "@fortawesome/free-solid-svg-icons";
import { GetStats } from "../api";
import { shallowEqual, useSelector } from "react-redux";

const Cards = () => {
  const [ loading, setLoading ] = useState(true);
  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const [statsList, setStatsList] = useState([
    {
      icon: faUsers,
      title: "Total Training",
      count: 0,
    },
    {
      icon: faClipboardCheck,
      title: "Total Enrollments",
      count: "N/A",
    },
    {
      icon: faPoll,
      title: "Total Balance",
      count: "N/A",
    },
  ]);


  const getStats = async () => {
    setLoading(true);
    try{
      let stats = await GetStats(user.organization);
      let data = stats.data.data;

      let tmp = statsList;
      tmp[0].count = data.traning;

      setStatsList([...tmp]);

    }catch(ex){
      console.log(ex);
    }finally{
      setLoading(false);
    }
  }

  React.useEffect(()=>{
    getStats()
  }, [])
  return (
    <Box container className="mx-20 mt-10">
      <Grid container spacing={5}>
        {statsList.map((item) => (
          <Grid item xs={12} sm={4}>
            <Card className="shadow-sm rounded-lg">
              <Card.Body className="position-relative px-0 py-0">
                <Grid container className="p-3" direction="row">
                  <Grid
                    item
                    md={3}
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                    container
                    alignItems="start"
                    justifyContent="center"
                  >
                    <FontAwesomeIcon icon={item.icon} size="3x" />
                  </Grid>

                  <Grid item md={9} className="pl-4">
                    <Typography variant="h6">{item.title}</Typography>
                    {loading ? (
                      <Box className="py-1">
                      <CircularProgress />
                    </Box>
                    ) : (
                      <Typography variant="h5" color="primary">
                        {item.count ? item.count : `- -`}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Card.Body>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Cards;
